import * as React from 'react';
import { ProductDetailTitle } from './ProductDetailTitle.js';
import { getBrandLink } from '../utils/get-brand-link.js';
import { useProductData } from '../../../context/ProductContext.js';

const ProductDetailTitleContainer = ()=>{
    const { activeVariant: { displayName , sku  } , product: { brandName  } ,  } = useProductData();
    const brandUrl = React.useMemo(()=>typeof window === 'undefined' ? undefined : getBrandLink(brandName, window.location.pathname)
    , [
        brandName
    ]);
    return /*#__PURE__*/ React.createElement(ProductDetailTitle, {
        title: displayName,
        subtitle: brandName,
        href: brandUrl,
        sku: sku
    });
};

export { ProductDetailTitleContainer };
//# sourceMappingURL=ProductDetailTitleContainer.js.map
